import { render, staticRenderFns } from "./group-system-notice-element.vue?vue&type=template&id=fec60276&scoped=true&"
import script from "./group-system-notice-element.vue?vue&type=script&lang=js&"
export * from "./group-system-notice-element.vue?vue&type=script&lang=js&"
import style0 from "./group-system-notice-element.vue?vue&type=style&index=0&id=fec60276&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec60276",
  null
  
)

export default component.exports